<template>
  <div class="app-data-filter__group">
    <button
      :id="ariaLabelGroupToggler"
      :aria-expanded="opened ? 'true' : 'false'"
      class="app-data-filter__button app-data-filter__group-opener"
      @click="toggleOpenGroup"
    >
      <span class="app-data-filter__group-title">{{ group.title }}</span>

      <span v-if="!opened" class="app-data-filter__group-opener-icon">+</span>
      <span v-else class="app-data-filter__group-opener-icon opened">–</span>
    </button>

    <CollapseTransition :duration="200">
      <div v-if="opened" class="app-data-filter__group-items" :aria-labelledby="ariaLabelGroupToggler">
        <AppDataFilterInputRange
          :min="group.min"
          :max="group.max"
          :step="group.step"
          :value="value"
          :label-from="`Min ${group.title.toLowerCase()}`"
          :label-to="`Max ${group.title.toLowerCase()}`"
          @input="onChange"
        >
          <template #default="{ from, to }"> {{ from }} - {{ to }} </template>
        </AppDataFilterInputRange>
      </div>
    </CollapseTransition>
  </div>
</template>

<script>
import CollapseTransition from '@/components/transitions/CollapseTransition.vue';
import AppDataFilterInputRange from '@/components/data-filter/AppDataFilterInputRange.vue';

export default {
  components: { AppDataFilterInputRange, CollapseTransition },
  props: {
    group: {
      type: Object,
      required: true,
    },
    toggler: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      opened: false,
    };
  },
  computed: {
    ariaLabelGroupToggler() {
      return `${this.group.itemsType}GroupToggler`;
    },
  },
  watch: {
    toggler: {
      handler(newValue) {
        this.opened = newValue;
      },
      immediate: true,
    },
  },
  methods: {
    toggleOpenGroup() {
      this.opened = !this.opened;
      this.$emit('toggle', { itemsType: this.group.itemsType, opened: this.opened });
    },
    onChange([from, to]) {
      const isFullRange = from === this.group.min && to === this.group.max;
      this.$emit('update', isFullRange ? null : [from, to]);
    },
  },
};
</script>

<style lang="scss" scoped>
.app-data-filter {
  &__group-items {
    margin-top: 36px;
  }
}
</style>
